import { Info } from "lucide-react";

/**
 * Shows a small badge with the remaining daily quota for an AI feature.
 * kind: "chat" | "decode"
 * usage: user.usage object from AuthContext (may be undefined for older sessions)
 * limit: max allowed per day
 */
export default function QuotaBadge({ kind, limit, usage, lang, testid }) {
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const entry = (usage || {})[kind] || {};
  const used = entry.date === today ? Number(entry.count) || 0 : 0;
  const remaining = Math.max(0, limit - used);
  const exhausted = remaining === 0;
  return (
    <div
      className={`mb-4 inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm ${
        exhausted
          ? "border-[#A762B1]/40 bg-[#A762B1]/10 text-[#6E3978]"
          : "border-[#A762B1]/40 bg-[#A762B1]/10 text-[#1B4C36]"
      }`}
      data-testid={testid}
    >
      <Info className="h-3.5 w-3.5" />
      {lang === "fr" ? (
        <>
          <strong>{remaining}</strong>&nbsp;/&nbsp;{limit} restantes aujourd'hui
        </>
      ) : (
        <>
          <strong>{remaining}</strong>&nbsp;/&nbsp;{limit} left today
        </>
      )}
    </div>
  );
}
